import Vue from 'vue';
import Router from 'vue-router';

import Home from './routes/home';
import Users from './routes/users';
import Courses from './routes/courses';
import Events from './routes/events';
import Blog from './routes/blog';
import Pages from './routes/pages';
import Contact from './routes/contact';
import News from './routes/news';
import Login from './routes/login';
import NotFound from './routes/404';
import Faq from './routes/faq';
import Menu from './routes/menu';
import Images from './routes/images';
import Students from './routes/students';
import UserLogs from './routes/user_logs';
import StudentsTerms from './routes/students_terms';
import TermFiles from './routes/term_files';

Vue.use(Router)

var allRoutes = [];
allRoutes = allRoutes.concat(
	Home,
	Courses,
	Faq,
	Events,
	Blog,
	Pages,
	Menu,
	Contact,
	News,
	Login,
	Users,
	Images,
	Students,
	NotFound,
    UserLogs,
    StudentsTerms,
    TermFiles,
);

export default new Router({
	mode: 'history',
	routes: allRoutes
})
